<h1 class="text-lg font-semibold m-6 text-uppercase text-gray-600" style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">
  {{ 'SIDEBAR.MANAGEMENT' | translate }} / {{ 'SIDEBAR.DACUS' | translate }}
</h1>

<div class="container mx-auto px-4">
    <mat-card *ngIf="filteredTraps.length > 0" class="p-4 shadow-md">
      <div id="map" class="w-full h-64"></div>
      <div class="flex justify-around items-center my-4">
        <div class="flex gap-6">
          <div class="my-2">
            <canvas baseChart [type]="'pie'" [datasets]="pieChartData" [labels]="pieChartLabels" 
              [options]="pieChartOptions" [legend]="pieChartLegend" style="height: 150px;">
            </canvas>
          </div>
          <div class="mt-6">
            <canvas baseChart [type]="'bar'" [datasets]="barChartData" [labels]="barChartLabels" 
              [options]="barChartOptions" [legend]="barChartLegend" style="height: 250px;">
            </canvas>
          </div>
        </div>
      </div>
    </mat-card>
  <div class="col-2 p-1 mt-4 pb-3 float-right">
    <button class="col-12" mat-raised-button id="addButton" (click)="addTrap()">
      <i class="fa-solid fa-plus" style="color: rgb(65, 65, 65);"></i>
      <span style="font-size: small; color: rgb(65, 65, 65);">
        {{ 'DACUS.ADD' | translate }}
      </span>
    </button>
  </div>
  <div class="row mt-3">
    <div class="lg:w-3/12">
      <div class="lg:w-full mat-card img-fluid float-left border-info" id="filter">
        <div class="mat-card-body">
          <div class="row">
            <div class="lg:w-9/12 d-flex align-items-left justify-content-left">
              <mat-form-field class="example-form-field w-full">
                <mat-label>{{ 'UPLOAD.TYPE' | translate }}</mat-label>
                <mat-select [(ngModel)]="type" (selectionChange)="filterTraps()" [ngModelOptions]="{standalone: true}">
                  <mat-option *ngFor="let key of types" [value]="translatedTypes[key]">
                    {{ translatedTypes[key] }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="lg:w-3/12">
              <img class="img-fluid mx-auto d-block mt-2" src="../../../../assets/trap.png" width="50">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="lg:w-3/12">
      <div class="lg:w-full mat-card img-fluid float-left border-info" id="filter">
        <div class="mat-card-body">
          <div class="row">
            <div class="lg:w-9/12 d-flex align-items-left justify-content-left">
              <mat-form-field class="example-form-field w-full">
                <mat-label>{{ 'DACUS.PLOTS' | translate }}</mat-label>
                <mat-select [(ngModel)]="plotCode" (selectionChange)="filterTraps()" 
                  [ngModelOptions]="{ standalone: true }" multiple>
                  <mat-option *ngFor="let code of plotCodes" [value]="code[0]">
                    {{ code[0] }} - {{ code[1] }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="lg:w-3/12">
              <img class="img-fluid mx-auto d-block mt-2" src="../../../../assets/land.png" width="50">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="lg:w-3/12">
      <div class="mat-card img-fluid float-center border-info" id="filter">
        <div class="mat-card">
          <div class="mat-card-body">
            <mat-form-field class="example-form-field w-full">
              <mat-label>{{ 'DACUS.DATES' | translate }}</mat-label>
              <mat-date-range-input [rangePicker]="rangePicker">
                <input matStartDate [(ngModel)]="startDate" (dateChange)="updateStartDate($event)">
                <input matEndDate [(ngModel)]="endDate" (dateChange)="updateEndDate($event)">
              </mat-date-range-input>
              <mat-datepicker-toggle matIconSuffix [for]="rangePicker"></mat-datepicker-toggle>
              <mat-date-range-picker #rangePicker>
                <mat-date-range-picker-actions>
                  <button mat-button matDateRangePickerCancel>Cancel</button>
                  <button mat-raised-button color="primary" matDateRangePickerApply>Apply</button>
                </mat-date-range-picker-actions>
              </mat-date-range-picker>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
    <div class="lg:w-3/12">
      <button mat-button color="warn" class="mt-3" (click)="resetFilters()">
        {{ 'DACUS.RESET' | translate }}
      </button>
    </div>
  </div>

  <mat-card *ngIf="filteredTraps.length > 0" class="p-4 my-4 shadow-md">
    <mat-accordion class="text-gray-400">
      <ng-container *ngFor="let trap of filteredTraps; let i = index">
        <mat-expansion-panel class="m-2 py-2" hideToggle>
          <mat-expansion-panel-header (click)="togglePanel(i)">
            <mat-panel-title>
              <mat-card-header>
                <div class="col-6">
                  <img id="plot_field" src="../../../../assets/trap.png" alt="Trap Image" 
                    class="mb-3 text-center img-fluid mx-auto rounded-rectangle img-thumbnail shadow-md">
                </div>
              </mat-card-header>
              <div class="mr-2 text-lg text-gray-600">
                #{{ i + 1 }}
              </div>
              <div class="mx-2 text-gray-700">
                {{ 'HOME.PLOT' | translate }} {{ trap.plotCode }} - {{ trap.location }}
              </div>
              <div class="mx-2 text-gray-700">
                {{ 'DACUS.TRAP_NAME' | translate }} {{ trap.trap_num }}
              </div>
            </mat-panel-title>
            <mat-panel-description>
              <div class="grid grid-cols-4 gap-2 items-center justify-around gray-700">
                <div class="flex items-center">
                  {{trap.trap_type}}
                </div>
                <div class="flex items-center">
                  <mat-icon class="text-xl mx-2 text-gray-500">place</mat-icon>
                  <div>
                    <p class="text-sm">{{ trap.coordinates[0].lat }}</p>
                    <p class="text-sm">{{ trap.coordinates[0].lon }}</p>
                  </div>
                </div>
                <div class="flex items-center">
                  <mat-icon class="text-xl mx-2 text-gray-500">bug_report</mat-icon>
                  <p class="text-sm">{{ 'DACUS.TOTAL' | translate }}: {{ trap.measurements[0].fly_total }}</p>
                </div>
                <div class="flex items-center">
                  <mat-icon class="text-xl mx-2 text-gray-500">calendar_today</mat-icon>
                  <p class="text-sm">{{ 'DACUS.PLACED' | translate }}: {{ trap.placement_date | date: 'dd/MM/yyyy'}}</p>
                </div>
              </div>
            </mat-panel-description>
            <mat-icon class="mt-8 text-gray-500"
                [class.rotate-icon]="expandedPanelIndex === i">keyboard_arrow_down</mat-icon>
          </mat-expansion-panel-header>
          <div class="text-gray-500">
            <h6 class="mt-6 text-lg font-bold uppercase">
              {{ 'DACUS.MEASUREMENTS' | translate }}
            </h6>
            <ng-container *ngFor="let measurement of trap.measurements; let measurementIndex = index">
              <mat-card class="mt-3 p-4 bg-gray-50 shadow-md rounded-lg">
                <mat-card-title class="text-gray-600 mb-2">
                  #{{ measurementIndex + 1 }} - {{ (measurement.measurement_date | date: 'dd/MM/yyyy') || 'N/A' }}
                </mat-card-title>
                <mat-card-content>
                  <div class="flex flex-col justify-evenly text-lg items-center text-gray-500">
                    <div class="flex flex-wrap justify-around gap-4">
                      <div>
                        <p><strong class="uppercase">{{ 'DACUS.FEMALE_FLY' | translate }}:</strong> {{ measurement.fly_female }}</p>
                        <p><strong class="uppercase">{{ 'DACUS.MALE_FLY' | translate }}:</strong> {{ measurement.fly_male }}</p>
                        <p><strong class="uppercase">{{ 'DACUS.TOTAL_FLY' | translate }}:</strong> {{ measurement.fly_total }}</p>
                      </div>
                      <div>
                        <p><strong class="uppercase">{{ 'DACUS.DISEASE' | translate }}:</strong> {{ measurement.disease_count }}</p>
                        <p><strong class="uppercase">{{ 'DACUS.LARVA' | translate }}:</strong> {{ measurement.mean_larval }}</p>
                        <p><strong class="uppercase">{{ 'DACUS.ACTION' | translate }}:</strong> {{ measurement.action ? measurement.action.join(', ') : 'N/A' }}</p>
                      </div>
                    </div>
                    <p class="text-md text-gray-500 mt-4">
                      <strong class="uppercase">{{ 'DACUS.COMMENTS' | translate }}:</strong>
                      {{ measurement.comments || '-' }}
                    </p>
                  </div>
                </mat-card-content>
              </mat-card>
            </ng-container>
          </div>
          <div class="flex justify-end mt-4">
            <button mat-icon-button color="warn" (click)="confirmDelete(trap)">
              <mat-icon style="color: red;">delete</mat-icon>
            </button>
            <button mat-icon-button color="primary" (click)="editTrap(trap)">
              <mat-icon style="color: #6aabff;">edit</mat-icon>
            </button>
          </div>
        </mat-expansion-panel>
      </ng-container>
    </mat-accordion>
  </mat-card>
</div>
